module.exports = __webpack_public_path__ + "img/elec_bottom1_s.1334efb3.png";